import {getUserInfo} from '../utils/auth'
const menulist = [
  {
    path: '/hospital',
    remark: "layout",
    name: '医院管理',
    redirect: '/hospital/listmy',
    hidden: false,
    meta: { title: '医院管理', icon: 'fa fa-list' },
    children: [
      {
        path: 'list',
        name: '医院列表',
        remark: "hospitallist",
        role: 1,
        hidden: false,
        meta: { title: '医院列表' }
      },
      {
        path: 'listmy',
        name: '我的医院',
        remark: "hospitallistmy",
        hidden: false,
        meta: { title: '我的医院' },
        children:[]
      },
      {
        path: 'detail',
        name: '医院详情',
        remark: "hospitaldetail",
        hidden: true,
        meta: { title: '医院详情' }
      }
    ]
  },
  {
    path: '/workorder',
    remark: "layout",
    name: '工单管理',
    redirect: '/workorder/list',
    hidden: false,
    meta: { title: '工单管理', icon: 'fa fa-flag' },
    children: [
      {
        path: 'list',
        name: '工单列表',
        remark: "workorderlist",
        hidden: false,
        meta: { title: '工单列表' }
      },
      {
        path: 'listmy',
        name: '我的工单',
        remark: "workorderlistmy",
        hidden: false,
        meta: { title: '我的工单' }
      },
      {
        path: 'detail',
        name: '工单详情',
        remark: "workorderdetail",
        hidden: true,
        meta: { title: '工单详情' }
      }
    ]
  },
  {
    path: '/statistics',
    remark: "layout",
    name: '统计管理',
    redirect: '/statistics/list',
    hidden: false,
    meta: { title: '统计管理', icon: 'fa fa-area-chart' },
    children: [
      {
        path: 'list',
        name: '数据统计',
        remark: "statisticslist",
        hidden: false,
        meta: { title: '数据统计' },
        children:[]
      }
    ]
  },
  {
    path: '/user',
    remark: "layout",
    name: '系统管理',
    redirect: '/user/list',
    hidden: false,
    meta: { title: '系统管理', icon: 'fa fa-user-circle-o' },
    children: [
      {
        path: 'list',
        name: '用户管理',
        remark: "userlist",
        hidden: false,
        meta: { title: '用户管理' },
        children:[]
      },
      {
        path: 'permission',
        name: '职级管理',
        role: 1,
        remark: "permission",
        hidden: false,
        meta: { title: '职级管理' },
        children:[]
      }
    ]
  },
  {
    path: '/server',
    remark: "layout",
    name: '服务器管理',
    redirect: '/server/detail',
    hidden: true,
    meta: { title: '服务器管理', },
    children: [
      {
        path: 'detail',
        name: '服务器详情',
        remark: "serverdetail",
        hidden: true,
        meta: { title: '服务器详情' }
      }
    ]
  },
  {
    path: '/project',
    remark: "layout",
    name: '项目管理',
    redirect: '/project/detail',
    hidden: true,
    meta: { title: '项目管理' },
    children: [
      {
        path: 'detail',
        name: '项目详情',
        remark: "projectdetail",
        hidden: true,
        meta: { title: '项目详情' }
      }
    ]
  }
  // ,{
  //   path: '/documentation',
  //   remark: "documentation",
  //   name: '说明文档',
  //   hidden: true,
  //   meta: { title: '说明文档' }
  // }
  ,{
    path: '/duty',
    remark: "layout",
    name: '排班',
    redirect: '/duty/detail',
    hidden: false,
    meta: { title: '排班' , icon: 'fa fa-calendar-check-o'},
    children: [
      {
        path: 'detail',
        name: '排班',
        remark: "duty",
        hidden: false,
        meta: { title: '排班' },
        children:[]
      }
    ]
  }
]
function getRoleMenu(rM,data){
  const _userinfo = getUserInfo()
  const userRole = !_userinfo ? '' : _userinfo.role
  data.forEach((item) => {
    if(!item.role || !userRole || (item.role&&item.role>=userRole)) {
      let menu = Object.assign({},item);
      if(item.children && item.children.length>0){
        menu.children = [];
        let dataItem = item.children;
        getRoleMenu(menu.children,dataItem);
      }
      rM.push(menu)
    }
  })
}

export default (rMenu) => {
	getRoleMenu(rMenu,menulist)
}


// WEBPACK FOOTER //
// ./src/modules/web/data/menulistjson.js